import React from 'react';
import PropTypes from 'prop-types';
import { ICONS } from 'constants/icons';

import ReportDetails from './ReportDetails';
import { REPORT_TYPE_DISRUPTIVE } from '../ReservationFeedbackModalV2.constants';
import messages from '../ReservationFeedbackModalV2.messages';

const guidelines = [
  {
    icon: ICONS.pointUp,
    title: messages.disruptiveUserGuidelineExamplesTitle,
    description: [
      messages.disruptiveUserGuidelineLateDescription,
      messages.disruptiveUserGuidelinePolicyDescription,
      messages.disruptiveUserGuidelineRudeDescription,
    ],
    descriptionFooter: messages.disruptiveUserGuidelineSeriousBehaviorNote,
  },
  {
    icon: ICONS.clipboard,
    title: messages.disruptiveUserGuidelineIncludeTitle,
    description: [
      messages.disruptiveUserGuidelineDateDescription,
      messages.disruptiveUserGuidelineFactDescription,
      messages.disruptiveUserGuidelineFrequencyDescription,
      messages.disruptiveUserGuidelineStepsTakenDescription,
      messages.disruptiveUserGuidelineAffectedDescription,
    ],
  },
];

const DisruptiveUserReportDetails = ({
  fullName,
  profileUrl,
  venueId,
  reservationId,
  scheduleId,
  setProcessingStep,
  setSuccessStep,
  resizeModal,
  showSubmitError,
  onSubmitError,
}) => (
  <ReportDetails
    fullName={fullName}
    profileUrl={profileUrl}
    reasonType={messages.disruptiveUser}
    guidelines={guidelines}
    venueId={venueId}
    reservationId={reservationId}
    scheduleId={scheduleId}
    reportType={REPORT_TYPE_DISRUPTIVE}
    setProcessingStep={setProcessingStep}
    setSuccessStep={setSuccessStep}
    resizeModal={resizeModal}
    showSubmitError={showSubmitError}
    onSubmitError={onSubmitError}
  />
);

DisruptiveUserReportDetails.propTypes = {
  fullName: PropTypes.string,
  profileUrl: PropTypes.string,
  venueId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  reservationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  scheduleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  resizeModal: PropTypes.func,
  setProcessingStep: PropTypes.func.isRequired,
  setSuccessStep: PropTypes.func.isRequired,
  showSubmitError: PropTypes.bool,
  onSubmitError: PropTypes.func,
};

export default DisruptiveUserReportDetails;
